import { useEffect, useState } from 'react';
import { apiFetch } from '../config/api';
import styles from './DriverInvite.module.css';

const APP_STORE_URL = 'https://apps.apple.com/us/app/car-pool/id6762562471';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.nativ.carpool';

function formatDate(value) {
  if (!value) return '';
  const date = new Date(`${String(value).slice(0, 10)}T00:00:00`);
  return Number.isNaN(date.getTime())
    ? String(value).slice(0, 10)
    : date.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' });
}

export default function DriverInvite({ token }) {
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    apiFetch(`/driver-invites/public/${token}`)
      .then((res) => setInvite(res.data))
      .catch((err) => setError(err.message || 'This authorization link is not valid.'));
  }, [token]);

  if (error) return <Shell><div className={styles.errorText}>{error}</div></Shell>;
  if (!invite) return <Shell><div className={styles.help}>Loading authorization…</div></Shell>;

  const appUrl = `carpool://driver-invite/${encodeURIComponent(token)}`;
  // Someone who already has an account is not sent through signup again — the
  // request is waiting on their home screen for an Accept or Decline.
  const requiresAcceptance = Boolean(invite.requires_acceptance);

  return (
    <Shell>
      <div className={styles.eyebrow}>Car-Pool+ Driver Authorization</div>
      <h1 className={styles.title}>Continue in the Car-Pool+ app</h1>
      <p className={styles.help}>
        {invite.inviting_parent_name || 'A parent'} authorized you to pick up the children listed below.
        {requiresAcceptance
          ? ' You already have a Car-Pool+ account — open the app and accept the request on your home screen.'
          : ' Driver onboarding is available only in the Car-Pool+ app.'}
      </p>

      <div className={styles.inviteSummary}>
        <div className={styles.schoolName}>{invite.school_name}</div>
        <div className={styles.studentList}>
          {invite.students.map((student) => (
            <div key={student.id} className={styles.studentChip}>
              <span className={styles.studentName}>{student.f_name} {student.l_name}</span>
            </div>
          ))}
        </div>
        <div className={styles.window}>
          Authorized {formatDate(invite.start_date)} – {formatDate(invite.end_date)}
        </div>
      </div>

      <a className={styles.primaryBtn} href={appUrl}>Open Car-Pool+ App</a>
      <p className={styles.help}>Don’t have the app yet? Download it, then reopen this authorization link.</p>
      <div className={styles.appPromoButtons}>
        <a className={styles.appPromoBtn} href={APP_STORE_URL}>Download for iPhone</a>
        <a className={styles.appPromoBtn} href={PLAY_STORE_URL}>Download for Android</a>
      </div>
      <p className={styles.help}>
        {requiresAcceptance
          ? 'Sign in with your usual email address or phone number — there is no new account to create.'
          : 'Sign in with the email address or phone number used for this invitation.'}
      </p>
    </Shell>
  );
}

function Shell({ children }) {
  return <div className={styles.page}><div className={`glass-card ${styles.card}`}>{children}</div></div>;
}
